import styled from 'styled-components';
import { getMediaQueriesMFByTheme } from '../../../utils';

export const FooterWrapper = styled.footer`
    background: #ffffff;
    padding: 40px 35px 32px;
    border-top: 1px solid #e5e5e5;
    font-family: Amigo;
`;

export const Container = styled.div`
    max-width: 1110px;
    margin: 0 auto;
`;

export const FooterTop = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-bottom: 40px;
    justify-content: space-between;
    align-items: flex-start;

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).desktop} {
        gap: 80px;
        flex-direction: row;
    }
`;

export const FooterLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Logo = styled.a`
    cursor: pointer;
    svg {
        width: 120px;
        height: auto;
    }
`;

export const Socials = styled.div`
    display: flex;
    gap: 12px;

    a {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        padding: 0;
        margin: 0;
        cursor: pointer;
    }

    svg {
        display: block;
    }

    svg path {
        fill: #14142b;
        transition: fill 0.2s ease;
    }

    a:hover svg path {
        fill: #7d00ff;
    }
`;
export const FooterLinks = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).tablet} {
        flex-direction: row;
        gap: 60px;
    }
`;

export const Column = styled.div`
    h4 {
        box-sizing: border-box;
        color: rgb(17, 17, 17);
        display: block;
        font-family: Amigo;
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 10px;
        text-align: left;
        text-transform: uppercase;
        line-height: 1.2;
        display: block;
    }

    ul {
        display: flex;
        flex-direction: column;
        list-style: none;
        padding: 0;
        margin: 0;
        margin-bottom: 1rem;
        gap: 6px;
    }

    li {
        color: #6e6d6d;
        font-size: 14px;
        border-bottom: 0;
        font-family: Amigo;
        cursor: pointer;
    }

    li:hover {
        text-decoration: underline;
    }

    a {
        font-size: 14px;
        font-weight: 400;
        color: #6e6d6d;
        text-decoration: none;
        transition: color 0.2s ease;
        line-height: normal;
    }
`;

export const FooterBottom = styled.div`
    border-top: 1px solid #e5e5e5;
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 767px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).desktop} {
        flex-direction: row-reverse;
    }
`;

export const Copyright = styled.p`
    color: #6e6d6d;
    font-family: Amigo;
    font-size: 14px;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    vertical-align: middle;
    padding-top: 14px;

    &:hover {
        color: #14142b;
    }

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).desktop} {
        font-size: 16px;
    }
`;

export const BottomLinks = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    a {
        color: #6e6d6d;
        font-family: Amigo;
        font-size: 14px;
        display: flex;
        padding: 0;
        align-items: center;
        text-decoration: none;

        &:hover {
            color: #14142b;
        }
    }

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).tablet} {
        flex-direction: row;
        flex-wrap: wrap;
    }

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).desktop} {
        a {
            font-size: 16px;
        }
    }
`;

export const LivroReclamacoesContainer = styled.a`
    margin-top: 20px;

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).tablet} {
        margin-top: 0;
    }
`;
